import React from 'react';

import * as styles from './MarketoForm.module.css';

const FormContainer = ({ className, splitName, formId, fade, isNewDemo }) => {
  return (
    <form
      noValidate={true}
      className={[
        className,
        splitName ? styles.singleCol : styles.marketoForm,
        'marketo-form',
        fade,
        isNewDemo ? styles.isNewDemo : '',
      ].join(' ')}
      id={`mktoForm_${formId}`}
      data-component={'marketo-form'}
    />
  );
};

export default FormContainer;
